import React from 'react';

import { Button, Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconAlertTriangle, IconCircleX } from '@tabler/icons-react';
import useCancelAthleteClass from 'hooks/athleteClass/useCancelAthleteClass';
import { KiloClassAthleteRetrieve } from 'types';

import ModalCancelReservation from './ModalCancelReservation';

type CancelReservationSectionProps = {
  classData: KiloClassAthleteRetrieve;
  athleteKiloClassId: string;
  action: 'cancelReservation' | 'lateCancelReservation';
};

const CancelReservationSection = ({
  classData,
  athleteKiloClassId,
  action,
}: CancelReservationSectionProps): JSX.Element => {
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);

  const cancelReservationMutation = useCancelAthleteClass();

  const isLateCancel = action === 'lateCancelReservation';

  return (
    <>
      <Group px='lg' position='center'>
        <Button
          size='md'
          variant='outline'
          leftIcon={isLateCancel ? <IconAlertTriangle /> : <IconCircleX />}
          onClick={openModal}
          color='red'
          loading={cancelReservationMutation.isLoading}
        >
          {isLateCancel ? 'Late Cancel' : 'Cancel Reservation'}
        </Button>
      </Group>

      <ModalCancelReservation
        opened={modalOpened}
        handleClose={closeModal}
        cancelReservationMutation={cancelReservationMutation}
        athleteKiloClassId={athleteKiloClassId}
        kiloClass={classData}
      />
    </>
  );
};

export default CancelReservationSection;
